import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import { useEffect, useState } from "react";
import classes from "./Navbar.module.css";
import { Link } from "react-scroll";
import {
  Burger,
  Container,
  Group,
  Text,
  Transition,
  Paper,
  AppShell,
} from "@mantine/core";
import ThemeToggle from "../ThemeToggle/ThemeToggle";

export default function Navbar() {
  const [opened, { toggle }] = useDisclosure(false);
  const isMobile = useMediaQuery("(max-width: 805px)");
  const status = isMobile ? "mobile" : "desktop";
  const [isMounted, setIsMounted] = useState(false); // 👈 Tambahkan ini

  useEffect(() => {
    setIsMounted(true); // 👈 Set true setelah komponen mount
  }, []);


  return (
    <AppShell>
      <AppShell.Header className={classes.header}>
        <Container size="md" className={classes.inner}>
          <Text size="md">Alvian Ardhiansyah</Text>
          <Group gap={5} visibleFrom="xs">
            <Link
              to="about"
              className={classes.link}
              smooth={true}
              duration={500}
            >
              About
            </Link>
            <Link
              to="projects"
              className={classes.link}
              smooth={true}
              duration={500}
            >
              Projects
            </Link>
            <Link
              to="resume"
              className={classes.link}
              smooth={true}
              duration={500}
            >
              Resume
            </Link>
            <Link
              to="contact"
              className={classes.link}
              smooth={true}
              duration={500}
            >
              Contact
            </Link>
          </Group>
          {status === "desktop" && isMounted && <ThemeToggle status="desktop" />}
          <Burger opened={opened} onClick={toggle} hiddenFrom="xs" size="sm" />

          <Transition transition="scale-y" duration={250} mounted={opened}>
            {(styles) => (
              <Paper className={classes.dropdown} withBorder style={styles}>
                <Link
                  to="about"
                  className={classes.link}
                  smooth={true}
                  duration={500}
                >
                  About
                </Link>
                <Link
                  to="projects"
                  className={classes.link}
                  smooth={true}
                  duration={500}
                >
                  Projects
                </Link>
                <Link
                  to="resume"
                  className={classes.link}
                  smooth={true}
                  duration={500}
                >
                  Resume
                </Link>
                <Link
                  to="contact"
                  className={classes.link}
                  smooth={true}
                  duration={500}
                >
                  Contact
                </Link>
                {status === "mobile" && isMounted && <ThemeToggle status="mobile" />}
              </Paper>
            )}
          </Transition>
        </Container>
      </AppShell.Header>
    </AppShell>
  );
}
